"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmToast = void 0;
/* eslint-disable react/button-has-type */
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.SmToast = (0, react_1.forwardRef)((_a, ref) => {
    var { size, theme, state, title, icon, content, url, linkName, hasButtons, btnNameOne, btnNameTwo, className, onClickOne, onClickTwo } = _a, props = __rest(_a, ["size", "theme", "state", "title", "icon", "content", "url", "linkName", "hasButtons", "btnNameOne", "btnNameTwo", "className", "onClickOne", "onClickTwo"]);
    const toastRef = (0, react_1.useRef)(null);
    const mergedRef = ref || toastRef;
    const toastFooterClassnames = (0, classnames_1.default)('c-toast__footerAction d-flex', `${size === 'small' && 'container-fluid justify-content-start'}`, `${size !== 'small' && 'justify-content-between'}`, className);
    const toastClassnames = (0, classnames_1.default)('c-toast mr-5', `-${theme}`, `-${size}`, `-${state}`, className);
    return (react_1.default.createElement("div", Object.assign({ ref: mergedRef }, props, { className: toastClassnames }),
        react_1.default.createElement("section", { className: "c-toast__wrapper" },
            react_1.default.createElement("header", { className: "c-toast__header" },
                react_1.default.createElement("div", { className: "c-toast__headerIcon d-flex justify-content-start align-items-center" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("h5", { className: "c-toast__headerTitle" },
                            icon && react_1.default.createElement("i", { className: "material-icons" }, icon),
                            title))),
                react_1.default.createElement("div", { className: "c-toast__headerClosed" },
                    react_1.default.createElement("i", { className: "material-icons" }, "close"))),
            react_1.default.createElement("div", { className: "c-toast__body" },
                react_1.default.createElement("p", null, content)),
            hasButtons && (react_1.default.createElement("footer", { className: "c-toast__footer d-flex justify-content-between align-items-center" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("a", { href: url, className: "c-hyperlink -underscore" }, linkName)),
                react_1.default.createElement("div", { className: toastFooterClassnames },
                    react_1.default.createElement("button", { onClick: onClickOne, className: `c-button -primary -pills -outlined ${theme === 'club' && '-club'}` }, btnNameOne),
                    react_1.default.createElement("button", { onClick: onClickTwo, className: `c-button -primary -pills ${theme === 'club' && '-club'}` }, btnNameTwo)))))));
});
//# sourceMappingURL=index.js.map